import { fbt } from 'fbtee'
import { Heart } from 'lucide-react'
import { cn } from '../lib/utils'

interface Props {
  /** Lineup names the event's title doesn't already spell out, headliners first. */
  lineup: string[]
  /** Followed artists on the lineup — they lead, highlighted. */
  followed: string[]
  /** Whole lineup's length — when `lineup` isn't loaded, says how many play besides `followed`. */
  lineupSize?: number
  eventName: string
  className?: string
}

const inTitle = (eventName: string, name: string) => eventName.toLowerCase().includes(name.toLowerCase())

/**
 * The card's lineup subtitle, with the viewer's followed artists moved to the
 * front so truncation never hides them. A followed artist the title already
 * names isn't repeated.
 */
export function EventCardLineup({ lineup, followed, lineupSize = 0, eventName, className }: Props) {
  const lead = followed.filter(n => !inTitle(eventName, n))
  const leadSet = new Set(lead.map(n => n.toLowerCase()))
  const rest = lineup.filter(n => !leadSet.has(n.toLowerCase()))
  const more = lead.length > 0 && rest.length === 0 ? lineupSize - followed.length : 0

  return (
    <p className={cn('text-xs truncate text-on-image-muted', className)}>
      {lead.length > 0 && (
        <span className="font-medium text-on-image">
          <Heart className="inline size-3 -mt-0.5 mr-1 fill-interested text-interested" aria-hidden />
          {lead.join(', ')}
        </span>
      )}
      {lead.length > 0 && rest.length > 0 && ', '}
      {rest.join(', ')}
      {more > 0 && ' ' + fbt(
        '+' + fbt.param('count', more, { number: true }) + ' more',
        "After the followed artists on an event card's lineup line: how many other artists play",
      )}
      {lead.length === 0 && rest.length === 0 && ' '}
    </p>
  )
}
